import { Block, PrensaEngine, Typography } from '@xprog/prensa'
import React from 'react'
import first from 'lodash/first'
import find from 'lodash/find'
import get from 'lodash/get'
import last from 'lodash/last'

type AuthorProfileProps = {
  children?: any
  className?: string
  customProps?: {
    className?: string
  }
}
type providerType = {
  description: string
  title: string
  image: {
    byline: string
    caption: string
    url: string
  }
}
function providerAuthorProfileProps(props: any): providerType {
  const contents = get(props, 'contentData', [])
  const description = get(props, 'slotTemplateCode')
  const title = get(props, 'title')
  const imageId: string | undefined = first(props.slotImageMobileElements)
  const image =
    imageId && find(contents, { id: `policy:${last(imageId.split('/'))}` })
  return { description, title, image }
}
const AuthorImage = PrensaEngine.styled('img', {
  borderRadius: '50%',
  ml: '0px',
  height: '100px',
  width: '100px',
  mt: '-70px',
  '@lg': {
    mt: '0px',
    ml: '-70px',
    height: '140px',
    width: '140px'
  }
})
const AuthorProfile: React.FC<AuthorProfileProps> = (props) => {
  const className = props.customProps?.className
  const baseClassName = `AuthorProfile ${props?.className || ''} ${className}`
  const isDesktop = props?.customProps?.className?.includes('desktop')
  if (isDesktop) return <></>
  const { description, image, title } = providerAuthorProfileProps(props)
  return (
    <Block
      className={baseClassName}
      css={{
        backgroundColor: '#f4f4f4',
        align: ['column', 'center', 'middle'],
        px: '$0',
        py: '$4',
        mb: '$6',
        mx: '$3',
        mt: '70px',
        textAlign: 'center',
        width: 'calc(100% - $6)',
        '@lg': {
          align: ['row', 'left', 'middle'],
          px: '$0',
          py: '$4',
          ml: '70px',
          mt: '0px',
          mr: '0px',
          textAlign: 'left',
          width: 'calc(100% - 70px)'
        }
      }}
    >
      {image && image.url && <AuthorImage alt={image.caption} src={image.url} />}
      <Block
        className={baseClassName}
        css={{
          align: ['column', 'center', 'middle'],
          px: '$3',
          textAlign: 'center',
          width: '100%',
          '@lg': {
            align: ['column', 'left', 'middle'],
            px: '$6',
            textAlign: 'left'
          }
        }}
      >
        <Typography
          css={{
            color: '#4C362B',
            fontFamily: '$primary',
            fontSize: '16px',
            lineHeight: '20px',
            fontWeight: 700,
            letterSpacing: '0.2px',
            my: '$3',
            '@lg': {
              fontSize: '25px',
              lineHeight: '30px',
              mt: '$0'
            }
          }}
        >
          {title}
        </Typography>
        <Typography
          css={{
            color: '#000000',
            fontFamily: '$primary',
            fontSize: '14px',
            lineHeight: '19px',
            fontWeight: 400,
            letterSpacing: '0.2px',
            my: '$0',
            '@lg': {
              fontSize: '18px',
              lineHeight: '23px'
            }
          }}
        >
          {description}
        </Typography>
      </Block>
    </Block>
  )
}

export default AuthorProfile
